import { render, staticRenderFns } from "./campManagement_item.vue?vue&type=template&id=f42e3f9e"
import script from "./campManagement_item.vue?vue&type=script&lang=js"
export * from "./campManagement_item.vue?vue&type=script&lang=js"
import style0 from "./campManagement_item.vue?vue&type=style&index=0&id=f42e3f9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports